import Tools from '../Tools/Tools';
/**
 * Třída, která umožňuje nastavení barev a písma reklamy.
 */
class AdvertCustomization {
	constructor(section) {
		this.section = section.getElementsByClassName('Sklik-advert')[0];
		this.horizontalBox = this.section.querySelector('.SetColor--horizontal');
		this.verticalBox = document.querySelector('.SetColor--vertical');
		this.colorInput = this.horizontalBox.querySelector('.SetColor-input');

		this.lessColorsBox = this.horizontalBox.querySelector('.SetColor-box--lessColors');

		this.colorSettings = document.querySelector('.Form-section.Form-section--colorSettings');

		/**
		 * Existuje pouze jedna instance, která se po DOMu pousouva podle toho co nastavujeme.
		 */
		this.moreColorsBox = this.horizontalBox.querySelector('.SetColor-box--moreColors');

		this.isSafari = Tools.isSafari();

		this.initCustomization();
	}

	/**
	 * Jednotlivé položky reklamy zobrazují možnost změnu výběru barvy po najetí.
	 * Poslední duhová "kulička" otevírá color picker.
	 */
	initCustomization() {
		this.applyPredefinedColors();

		// Vytvoří color-picker (lib), po kliknutí na ikonu colorPicker.
		this.picker = new window.CP(this.horizontalBox.querySelector('.SetColor-item--colorPicker'), false);

		// Nastavuje barvy pomocí coler-pickeru.
		this.picker.on('change', (color) => this.setCustomColor('#' + color));

		this.onClickColorsBox();
		this.onClickVerticalBox();
		this.onClickFontList();
		this.onInputHexColor();
		this.onHoverToggleColorsBox();
	}

	/**
	 * Sets banner colors for the first time.
	 */
	setBanner() {
		const font = this.section.querySelector('.Sklik-advert-font');

		if (!font.value) {
			font.setAttribute('value', window.SSP.data.font);
		}

		const { fontFamily } = document.querySelector(`.SetFont-item[data-font="${font.value}"]`).style;

		this.section.style.borderColor = this.colors.border;
		this.section.style.background = this.colors.background;
		this.section.style.fontFamily = fontFamily;

		this.section.querySelector('.Sklik-advert-title').style.color = this.colors.title;

		this.section.querySelector('.Sklik-advert-description').style.color = this.colors.description;

		this.section.querySelector('.Sklik-advert-link').style.color = this.colors.link;
	}

	/**
	 * Nastaví styl banneru podle inputů v DOMu (zejména kvůli editaci zon).
	 */
	applyPredefinedColors() {
		const borderColor = this.section.querySelector('.Sklik-advert-border-color');

		const backgroundColor = this.section.querySelector('.Sklik-advert-background-color');

		const titleColor = this.section.querySelector('.Sklik-advert-title-color');

		const descriptionColor = this.section.querySelector('.Sklik-advert-description-color');

		const linkColor = this.section.querySelector('.Sklik-advert-link-color');
		this.colors = {
			background: backgroundColor.value || window.SSP.data.colors.background,
			border: borderColor.value || window.SSP.data.colors.border,
			description: descriptionColor.value || window.SSP.data.colors.text,
			link: linkColor.value || window.SSP.data.colors.link,
			title: titleColor.value || window.SSP.data.colors.title,
		};

		if (!borderColor.value || !titleColor.value) {
			borderColor.setAttribute('value', this.colors.border);
			backgroundColor.setAttribute('value', this.colors.background);
			titleColor.setAttribute('value', this.colors.title);
			descriptionColor.setAttribute('value', this.colors.description);
			linkColor.setAttribute('value', this.colors.link);
		}

		this.setBanner();
		this.checkContrast();
	}

	/**
	 * Zajištuje nastavení fontů včetně propsání hodnot do formuláře.
	 */
	onClickFontList() {
		const fontBox = this.verticalBox.querySelector('.SetFont-box');

		fontBox.addEventListener('click', (e) => {
			if (e.target.classList.contains('SetFont-item')) {
				this.setFont(e.target);
			}
		});

		fontBox.addEventListener('mouseleave', () => {
			this.toggleFontBox();
		});
	}

	/**
	 * 1. Nastaví font advert boxu.
	 * 2. Označí vybraný font v seznamu.
	 * 3. Propíše vybranou hodnotu do formuláře.
	 * @param {Element} elem
	 */
	setFont(elem) {
		this.section.style.fontFamily = elem.style.fontFamily;

		Array.from(elem.parentElement.getElementsByClassName('SetFont-item')).forEach((item) => {
			if (item !== elem) {
				item.classList.remove('is-selected');
			} else {
				item.classList.add('is-selected');
			}
		});

		this.section.querySelector('input.Sklik-advert-font').setAttribute('value', elem.getAttribute('data-font'));
	}

	/**
	 * Otevře výběr fontů.
	 */
	toggleFontBox() {
		this.verticalBox.querySelector('.SetAdvert-box').classList.toggle('is-visible');

		this.verticalBox.querySelector('.SetFont-box').classList.toggle('is-visible');
	}

	/**
	 * Zobrazí rozšířené nastavení barev nebo nastaví přednastavenou barvu.
	 */
	onClickColorsBox() {
		this.lessColorsBox.addEventListener('click', (e) => {
			if (e.target.classList.contains('SetColor-item--colorPicker')) {
				this.showColorPicker();
			} else if (e.target.classList.contains('SetColor-item')) {
				this.setPredefinedColor(e.target.getAttribute('data-color'), this.horizontalBox.previousSibling, 'color');
			}
		});

		this.moreColorsBox.addEventListener('click', (e) => {
			if (e.target.classList.contains('SetColor-item')) {
				if (this.moreColorsBox.parentElement.classList.contains('SetColor--vertical')) {
					this.setPredefinedColor(
						e.target.getAttribute('data-color'),
						this.section,
						this.moreColorsBox.getAttribute('data-setting'),
					);
				} else {
					this.setPredefinedColor(e.target.getAttribute('data-color'), this.horizontalBox.previousSibling, 'color');
				}
			}
		});
	}

	/**
	 * Zadávání barvy v HEX formátu #FFF apod.
	 */
	onInputHexColor() {
		this.colorInput.addEventListener('input', (e) => {
			const color = e.target.value;

			// Kontrola validity barvy v HEX.
			if (/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color)) {
				this.colorInput.classList.remove('is-invalid');
				this.setCustomColor(color);
				this.picker.set(color);
			} else {
				this.colorInput.classList.add('is-invalid');
			}
		});
	}

	/**
	 * Kliknutí na pravý box.
	 */
	onClickVerticalBox() {
		// Pokud opustím otevřenou paletu barev, tak jí schovám.
		this.moreColorsBox.addEventListener('mouseleave', (e) => {
			if (e.target.parentElement.classList.contains('SetColor--vertical')) {
				this.verticalBox.querySelector('.SetAdvert-box').classList.add('is-visible');

				this.verticalBox.querySelector('.SetColor-box').classList.remove('is-visible');

				this.picker.exit();
			}
		});

		// Otevře výber fontu nebo barev.
		this.verticalBox.addEventListener('click', (e) => {
			if (e.target.classList.contains('SetAdvert-item--font')) {
				this.toggleFontBox();
			} else if (e.target.classList.contains('SetAdvert-item--bg')) {
				this.showVerticalColorBox('background');
			} else if (e.target.classList.contains('SetAdvert-item--border')) {
				this.showVerticalColorBox('border');
			}
		});
	}

	/**
	 * Otevře paletu barev v pravém panelu.
	 * @param {string} type border | background
	 */
	showVerticalColorBox(type) {
		this.verticalBox.querySelector('.SetAdvert-box').classList.remove('is-visible');

		this.moreColorsBox.setAttribute('data-setting', type);
		this.verticalBox.appendChild(this.moreColorsBox);
		this.moreColorsBox.classList.add('is-visible');

		this.setCustomColor(this.colors[type]);
		this.picker.set(this.colors[type]);
		this.picker.enter();

		const [colorPickerElem] = document.getElementsByClassName('color-picker');

		colorPickerElem.style.top = 0;
		colorPickerElem.style.left = 0;
		this.moreColorsBox.appendChild(colorPickerElem);
	}

	/**
	 * Při najetí myši na itemy zobrazuje border a možnost nastavení barev.
	 */
	onHoverToggleColorsBox() {
		Array.from(this.section.getElementsByClassName('Sklik-advert-item-wrapper')).forEach((elem) => {
			// Zobrazí výběr barvy a přesune horizontalBox na správné místo.
			elem.addEventListener('mouseover', (e) => {
				if (
					e.target.classList.contains('Sklik-advert-title') ||
					e.target.classList.contains('Sklik-advert-description') ||
					e.target.classList.contains('Sklik-advert-link')
				) {
					e.target.parentElement.classList.add('is-visible');

					this.setElementsColorToPicker(this.colors[e.target.className.split('-')[2]]);

					Tools.insertAfter(this.horizontalBox, e.target);
				}
			});

			// Schová výběr barev a uzavře color-picker.
			elem.addEventListener('mouseleave', (e) => {
				const targetElement = e.target;

				if (targetElement.classList.contains('Sklik-advert-item-wrapper')) {
					if (this.isSafari) {
						// wtf 'data-touched'? Safari chybně vyvolává event 'mouseleave' a nejsem schopnej to opravit,
						// tak tento flag zabranuje nechtenemu zavření color pickeru.
						if (targetElement.getAttribute('data-touched') === 'true') {
							this.hideColorBox(targetElement);
							targetElement.setAttribute('data-touched', false);
						} else if (this.picker.visible) {
							targetElement.setAttribute('data-touched', true);
						} else {
							targetElement.classList.remove('is-visible');
						}
					} else {
						this.hideColorBox(targetElement);
					}
				}
			});
		});
	}

	/**
	 * Schová color box.
	 * @param {Element} elem
	 */
	hideColorBox(elem) {
		elem.classList.remove('is-visible');
		this.moreColorsBox.classList.remove('is-visible');
		this.lessColorsBox.classList.add('is-visible');
		this.picker.exit();
	}

	/**
	 * Nastaví v detailním colopickeru barvu vybraného elementu.
	 * @param {string} color
	 */
	setElementsColorToPicker(color) {
		this.moreColorsBox.querySelector('input').value = color;
		this.picker.set(color);
	}

	/**
	 * Uloží vybranou barvu do inputu formuláře, který bude odesílán.
	 * @param {string} name Jméno upravovaného inputu.
	 * @param {string} color Vybraná barva v HEX.
	 */
	setFormInput(name, color) {
		const input = `input.${name}-color`;

		this.section.querySelector(input).setAttribute('value', color);
		// Kontrola kontrastu.
		this.colors[name.split('-')[2]] = color;
		this.checkContrast();
	}

	/**
	 * Nastaví elementu předvybranou barvu.
	 * @param {string} color
	 * @param {Element} elem Element, který bude upravován.
	 * @param {string} property Property, jehož barva bude nastavena.
	 */
	setPredefinedColor(color, elem, property) {
		this.picker.set(color);

		this.colorInput.value = color;

		if (property === 'color') {
			elem.style[property] = color;
			this.setFormInput(elem.classList[0], color);
		} else if (property === 'background') {
			elem.style[property] = color;
			this.setFormInput('Sklik-advert-background', color);
		} else if (property === 'border') {
			elem.style.borderColor = color;
			this.setFormInput('Sklik-advert-border', color);
		}
	}

	/**
	 * Zobrazí color-picker.
	 */
	showColorPicker() {
		this.lessColorsBox.classList.remove('is-visible');
		this.horizontalBox.appendChild(this.moreColorsBox);
		this.moreColorsBox.setAttribute('data-setting', 'color');
		this.moreColorsBox.classList.add('is-visible');

		this.picker.enter();

		const colorPickerElem = document.querySelector('.color-picker');

		this.moreColorsBox.appendChild(colorPickerElem);
	}

	/**
	 * Nastaví elementu barvu vybranou pomocí color pickeru.
	 * @param {string} color Vybraná barva.
	 */
	setCustomColor(color) {
		// Element, jehož barva bude nastavena.
		let elem = null;
		const property = this.moreColorsBox.getAttribute('data-setting');

		if (property === 'color') {
			const wrapper = this.section.querySelector('.Sklik-advert-item-wrapper.is-visible');

			if (!wrapper) {
				return;
			}

			[elem] = wrapper.children;
			elem.style[property] = color;
			this.setFormInput(elem.classList[0], color);
		} else {
			elem = this.section;

			if (property === 'background') {
				elem.style[property] = color;
				this.setFormInput('Sklik-advert-background', color);
			} else if (property === 'border') {
				elem.style.borderColor = color;
				this.setFormInput('Sklik-advert-border', color);
			}
		}

		this.colorInput.value = color;
	}

	/**
	 * Kontrola kontrastu vytvářeného banneru.
	 */
	checkContrast() {
		const warning = this.colorSettings.querySelector('.Sklik-advert-warning');
		const result = {
			description: this.checkColorCombination('description'),
			link: this.checkColorCombination('link'),
			title: this.checkColorCombination('title'),
		};

		if (result.title && result.description && result.link) {
			warning.classList.remove('is-visible');
		} else {
			const text = this.getWarningText(result);

			this.showWarning(warning, text);
		}
	}

	/**
	 * Kontrola kontrastu daného prvku (title, link, description) vůči pozadí.
	 * @param {string} type
	 * @return {boolean}
	 */
	checkColorCombination(type) {
		const ratio = this.getContrastRatio(this.hexToRgb(this.colors.background), this.hexToRgb(this.colors[type]));

		if (type === 'title' && ratio < 2) {
			return false;
		} else if (type === 'link' && ratio < 2) {
			return false;
		} else if (type === 'description' && ratio < 3) {
			return false;
		} else {
			return true;
		}
	}

	/**
	 * Přeloží chybovou hlášku.
	 * @param {string} type
	 * @return {string}
	 */
	getTranslationForWarning(type) {
		return window.SSP.translations.form.labels[type];
	}

	/* eslint-disable custom-oxlint/jsdoc__require-asterisk-prefix */
	/**
	 * Naformátuje daný objekt do formátu "(titulek, popis)".
	 * @param {Object} result {
			'title': true | false,
			'description': true | false,
			'link': true | false
		}
	 */
	/* eslint-enable custom-oxlint/jsdoc__require-asterisk-prefix */
	getWarningText(result) {
		return (
			'(' +
			Object.keys(result)
				.filter((type) => !result[type])
				.map((type) => this.getTranslationForWarning(type))
				.join(', ') +
			')'
		);
	}

	/**
	 * Zobrazí warning pod bannerem.
	 * @param {Element} warning
	 * @param {string} text (titulek, popis)
	 */
	showWarning(warning, text = '') {
		if (!warning.classList.contains('is-visible')) {
			warning.classList.add('is-visible');
		}

		warning.textContent = window.SSP.translations.form.labels.badColorContrast + ' ' + text;
	}

	/**
	 * Vrátí kontrat dvou daných barev.
	 * @param {object} rgb1
	 * @param {object} rgb2
	 * @return {number}
	 */
	getContrastRatio(rgb1, rgb2) {
		let ratio = 1;
		const l1 = this.getLuminance([rgb2.r / 255, rgb2.g / 255, rgb2.b / 255]);
		const l2 = this.getLuminance([rgb1.r / 255, rgb1.g / 255, rgb1.b / 255]);

		if (l1 >= l2) {
			ratio = (l1 + 0.05) / (l2 + 0.05);
		} else {
			ratio = (l2 + 0.05) / (l1 + 0.05);
		}

		ratio = Math.floor(ratio * 1000) / 1000;

		return ratio;
	}

	/**
	 * Vrátí jas pro danou barvu.
	 * @param {*} rgb
	 */
	getLuminance(rgb) {
		for (let i = 0; i < rgb.length; i++) {
			if (rgb[i] <= 0.03928) {
				rgb[i] = rgb[i] / 12.92;
			} else {
				rgb[i] = Math.pow((rgb[i] + 0.055) / 1.055, 2.4);
			}
		}

		const l = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];

		return l;
	}

	/**
	 * Převádí HEX to RGB.
	 * @param {*} hex
	 */
	hexToRgb(hex) {
		if (hex.length === 4) {
			hex = `${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;
		}

		const result = /^#?([a-fA-F\d]{2})([a-fA-F\d]{2})([a-fA-F\d]{2})$/i.exec(hex);

		return result
			? {
					b: parseInt(result[3], 16),
					g: parseInt(result[2], 16),
					r: parseInt(result[1], 16),
				}
			: null;
	}
}

export default AdvertCustomization;
